module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/rachel-malick-56fbd5c8d2821ee75a912dc8bbbeaf2e.jpg";